import vegImg from "../media/images/filters/veg.webp";
import nonvegImg from "../media/images/filters/nonveg.webp";
import burgerImg from "../media/images/filters/burger.webp";
import pizzaImg from "../media/images/filters/pizza.webp";
import indianImg from "../media/images/filters/indian.webp";
import chineseImg from "../media/images/filters/chinese.webp";
import italianImg from "../media/images/filters/italian.webp";
import dessertImg from "../media/images/filters/dessert.webp";
import drinkImg from "../media/images/filters/drink.webp";

export const filterData = [
  { id: 1, name: "Veg", img: vegImg, isSelected: false, ref: "veg" },
  { id: 2, name: "Non-veg", img: nonvegImg, isSelected: false, ref: "nonveg" },
  { id: 3, name: "Burgers", img: burgerImg, isSelected: false, ref: "burgers" },
  { id: 4, name: "Pizzas", img: pizzaImg, isSelected: false, ref: "pizzas" },
  { id: 5, name: "Indian", img: indianImg, isSelected: false, ref: "indian" },
  { id: 6, name: "Chinese", img: chineseImg, isSelected: false, ref: "chinese" },
  { id: 7, name: "Italian", img: italianImg, isSelected: false, ref: "italian" },
  { id: 8, name: "Desserts", img: dessertImg, isSelected: false, ref: "desserts" },
  { id: 9, name: "Beverages", img: drinkImg, isSelected: false, ref: "beverages" },
];
